enum STORAGE_NAME {
  CSC_STORE = 'csc-store',
  CSC_USER_DATA_STORE = 'csc-user-data-store',
  CSC_STATE = 'csc-state',
}

export const keys = {
  HTTP_MOCK: 'http-mock',
  ADD_HTTP_TIMEOUT: 'add-http-timeout',
  USER_INPUT_DATA: 'user-input-data',
  OUT_OF_SERVICE: 'out-of-service',
}

export enum USER_INPUT_DATA {
  DRIVER_FIRST_NAME = 'driver-first-name',
  DRIVER_LAST_NAME = 'driver-last-name',
  DRIVER_CITIZENSHIP = 'driver-citizenship',
  DRIVER_DATE_OF_BIRTH = 'driver-date-of-birth',
  DRIVER_GENDER = 'driver-gender',
  DRIVER_DOCUMENT_NUMBER = 'driver-document-number',
  DRIVER2_FIRST_NAME = 'driver2-first-name',
  DRIVER2_LAST_NAME = 'driver2-last-name',
  DRIVER2_CITIZENSHIP = 'driver2-citizenship',
  DRIVER2_DATE_OF_BIRTH = 'driver2-date-of-birth',
  DRIVER2_GENDER = 'driver2-gender',
  DRIVER2_DOCUMENT_NUMBER = 'driver2-document-number',
}

export const getStore = (key?: string) => {
  const data: string = localStorage.getItem(STORAGE_NAME.CSC_STORE) || ''
  try {
    const parsed: any = JSON.parse(data)
    return key ? parsed[key] : parsed
  } catch (e) {
    return null
  }
}

export const setStore = (key: string, value: any) => {
  const data: string = localStorage.getItem(STORAGE_NAME.CSC_STORE) || ''
  let parsed: any = {}
  try {
    parsed = JSON.parse(data)
  } catch (e) {
    // ignore
  }
  localStorage.setItem(STORAGE_NAME.CSC_STORE, JSON.stringify({ ...parsed, [key]: value }))
}

export const setUserDataStore = (data: {[key in USER_INPUT_DATA]?: string}) => {
  const storage: string = localStorage.getItem(STORAGE_NAME.CSC_USER_DATA_STORE) || ''
  let parsed: any = {}
  try {
    parsed = JSON.parse(storage)
  } catch (e) {
    // ignore
  }
  localStorage.setItem(STORAGE_NAME.CSC_USER_DATA_STORE, JSON.stringify({ ...parsed, ...data }))
}

export const getUserDataStore = (key: USER_INPUT_DATA) => {
  const data: string = localStorage.getItem(STORAGE_NAME.CSC_USER_DATA_STORE) || ''
  try {
    const parsed: any = JSON.parse(data)
    return key ? parsed[key] : parsed
  } catch (e) {
    return null
  }
}

export const setStateToStore = (value: any) => {
  localStorage.setItem(STORAGE_NAME.CSC_STATE, JSON.stringify(value))
}

export const getStateFromStore = () => {
  const data: string = localStorage.getItem(STORAGE_NAME.CSC_STATE) || ''
  try {
    return JSON.parse(data)
  } catch (e) {
    return null
  }
}

export const clearStateInStore = () => {
  localStorage.removeItem(STORAGE_NAME.CSC_STATE)
}